import { format } from 'date-fns'
import { useMemo } from 'react'

export function useDisplayDate(): (d: Date) => string {
	return useMemo(() => {
		return (d: Date) => {
			return format(d, 'MMM d, yyyy')
		}
	}, [])
}
